export function isArrayEqual(a: string[], b: string[]) {
    if (a.length === b.length) {
        if (a.toSorted().toString() === b.toSorted().toString()) {
            return true;
        }
    }
    return false;
}
